import { Typography } from "@mui/material";
import BoxColorWrapper from "./BoxColorWrapper";
import PropTypes from "prop-types";
import { tyomaa_ajoOhje_getString } from "src/data/tyomaa/tyomaaFunctions";

export default function AsiakasContainer(props) {
  const keikkaData = props.keikkaData;
  const rows = props.rows || 5;
  const tyomaa = keikkaData.tyomaa;
  const ajoOhje = rows > 4 && tyomaa_ajoOhje_getString(props.keikkaData.tyomaa);

  if (keikkaData == null || keikkaData.tyomaa == null || keikkaData.tyomaa.tyomaId === 0)
    return <BoxColorWrapper alignItems="left">Työmaa: ?</BoxColorWrapper>;
  const row1 = () => {
    let r1 = "";
    let r2 = "";
    // tyomaaNimi tai osoite1 / asiakasNimi
    if (tyomaa) {
      if (tyomaa.tyomaaNimi && tyomaa.tyomaaNimi.length > 1) r1 = tyomaa.tyomaaNimi;
      else r1 = ""; // tyomaa.tyomaaOsoiteString;
    }
    if (keikkaData.asiakas && keikkaData.asiakas.asiakasId > 0) {
      r2 = keikkaData.asiakas.asiakasNimi;
    }
    return r1 + (r1 && r2 && " / ") + r2;
  };
  return (
    <BoxColorWrapper alignItems="left">
      {rows > 3 &&
        tyomaa &&
        keikkaData &&
        (tyomaa.tyomaaNimi.length > 2 || keikkaData.asiakas.asiakasId > 0) && (
          <>
            <Typography noWrap color="primary">
              {row1()}
            </Typography>
          </>
        )}
      <Typography
        noWrap
        sx={{
          fontSize: "15px",
        }}
        color="primary">
        {tyomaa ? tyomaa.tyomaaOsoiteString : ""}
      </Typography>
      {ajoOhje ? (
        <Typography
          noWrap
          sx={{
            fontStyle: "italic",
            fontSize: "13px",
          }}
          color="primary">
          {ajoOhje}
        </Typography>
      ) : (
        ""
      )}
    </BoxColorWrapper>
  );
}

AsiakasContainer.propTypes = {
  keikkaData: PropTypes.object,
  rows: PropTypes.number,
};
